import { useMutation, useQueryClient } from 'react-query';

import { initialBalancesApi } from 'src/Services/API';
import { UpdateInitialBalanceDto } from 'src/Services/API/generated';

interface UseUpdateInitialBalanceOptions {
  onSuccess?: () => void;
}

export const useUpdateInitialBalance = (options?: UseUpdateInitialBalanceOptions) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ assetId, id, data }: { assetId: string; id: string; data: UpdateInitialBalanceDto }) =>
      initialBalancesApi.initialBalancesControllerUpdate(assetId, id, data),
    {
      onSuccess: (_, { assetId }) => {
        queryClient.invalidateQueries(['fetch-initial-balances', assetId]);
        queryClient.invalidateQueries(['fetch-initial-balances-audit', assetId]);
        queryClient.invalidateQueries(['fetch-asset-member-balances', assetId]);
        queryClient.invalidateQueries(['fetch-expense-stats']);
        queryClient.invalidateQueries(['fetch-expense-balance']);
        queryClient.invalidateQueries(['fetch-household-balances']);
        queryClient.invalidateQueries(['fetch-personal-wallet']);
        queryClient.invalidateQueries(['fetch-member-forecast-summary']);
        options?.onSuccess?.();
      },
    }
  );
};
